// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-page[data-v-982bcf96]{padding:5em 0}.w-page h2[data-v-982bcf96],.w-page p[data-v-982bcf96]{margin-bottom:.75em}", ""]);
// Exports
module.exports = exports;
